import Default from "./InputLabel";
export * from "./InputLabel";

export default Default;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/InputLabel/index.ts